/* eslint-disable */
import Swiper from 'swiper/bundle'

console.log('aaaaaaaa');

new Swiper('.js-hero-slider', {
	loop: true,
	pagination: {
		el: '.c-hero__pagination',
		clickable: true,
	},
	navigation: {
		nextEl: '.c-hero__button--next',
		prevEl: '.c-hero__button--prev',
	},
	effect: 'fade',
	autoplay: {
		delay: 7000,
	},
})
